/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiKeyResponse } from '../models/api-key-response';
import { JwtAuthenticationResponse } from '../models/jwt-authentication-response';
import { LastVisitResponse } from '../models/last-visit-response';
import { login } from '../fn/member-resource/login';
import { Login$Params } from '../fn/member-resource/login';
import { membersApiKeyPut } from '../fn/member-resource/members-api-key-put';
import { MembersApiKeyPut$Params } from '../fn/member-resource/members-api-key-put';
import { membersForgotPasswordPut } from '../fn/member-resource/members-forgot-password-put';
import { MembersForgotPasswordPut$Params } from '../fn/member-resource/members-forgot-password-put';
import { membersGoogleLoginPost } from '../fn/member-resource/members-google-login-post';
import { MembersGoogleLoginPost$Params } from '../fn/member-resource/members-google-login-post';
import { membersLastVisitPut } from '../fn/member-resource/members-last-visit-put';
import { MembersLastVisitPut$Params } from '../fn/member-resource/members-last-visit-put';
import { membersMeCountryGet } from '../fn/member-resource/members-me-country-get';
import { MembersMeCountryGet$Params } from '../fn/member-resource/members-me-country-get';
import { membersMeDelete } from '../fn/member-resource/members-me-delete';
import { MembersMeDelete$Params } from '../fn/member-resource/members-me-delete';
import { membersMeGet } from '../fn/member-resource/members-me-get';
import { MembersMeGet$Params } from '../fn/member-resource/members-me-get';
import { membersNotifyPurchasePut } from '../fn/member-resource/members-notify-purchase-put';
import { MembersNotifyPurchasePut$Params } from '../fn/member-resource/members-notify-purchase-put';
import { membersRegisterEmailPut } from '../fn/member-resource/members-register-email-put';
import { MembersRegisterEmailPut$Params } from '../fn/member-resource/members-register-email-put';
import { membersRegisterPost } from '../fn/member-resource/members-register-post';
import { MembersRegisterPost$Params } from '../fn/member-resource/members-register-post';
import { membersResendEmailPost } from '../fn/member-resource/members-resend-email-post';
import { MembersResendEmailPost$Params } from '../fn/member-resource/members-resend-email-post';
import { membersResetPasswordPut } from '../fn/member-resource/members-reset-password-put';
import { MembersResetPasswordPut$Params } from '../fn/member-resource/members-reset-password-put';
import { membersSalesGet } from '../fn/member-resource/members-sales-get';
import { MembersSalesGet$Params } from '../fn/member-resource/members-sales-get';
import { membersVerifyPost } from '../fn/member-resource/members-verify-post';
import { MembersVerifyPost$Params } from '../fn/member-resource/members-verify-post';
import { SaleResponse } from '../models/sale-response';
import { UserCountryResponse } from '../models/user-country-response';
import { UserResponse } from '../models/user-response';

@Injectable({ providedIn: 'root' })
export class MemberResourceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `membersApiKeyPut()` */
  static readonly MembersApiKeyPutPath = '/members/api-key';

  /**
   * Set Api Key.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `membersApiKeyPut()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersApiKeyPut$Response(
    params?: MembersApiKeyPut$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<ApiKeyResponse>> {
    const obs = membersApiKeyPut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Set Api Key.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `membersApiKeyPut$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersApiKeyPut(
    params?: MembersApiKeyPut$Params,
    context?: HttpContext,
  ): Observable<ApiKeyResponse> {
    const resp = this.membersApiKeyPut$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ApiKeyResponse>): ApiKeyResponse => r.body),
    );
  }

  /** Path part for operation `membersForgotPasswordPut()` */
  static readonly MembersForgotPasswordPutPath = '/members/forgot-password';

  /**
   * Forgot Password.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `membersForgotPasswordPut()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersForgotPasswordPut$Response(
    params: MembersForgotPasswordPut$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<void>> {
    const obs = membersForgotPasswordPut(
      this.http,
      this.rootUrl,
      params,
      context,
    );
    return obs;
  }

  /**
   * Forgot Password.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `membersForgotPasswordPut$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersForgotPasswordPut(
    params: MembersForgotPasswordPut$Params,
    context?: HttpContext,
  ): Observable<void> {
    const resp = this.membersForgotPasswordPut$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `membersGoogleLoginPost()` */
  static readonly MembersGoogleLoginPostPath = '/members/google/login';

  /**
   * Google Login.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `membersGoogleLoginPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  membersGoogleLoginPost$Response(
    params: MembersGoogleLoginPost$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<JwtAuthenticationResponse>> {
    const obs = membersGoogleLoginPost(
      this.http,
      this.rootUrl,
      params,
      context,
    );
    return obs;
  }

  /**
   * Google Login.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `membersGoogleLoginPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  membersGoogleLoginPost(
    params: MembersGoogleLoginPost$Params,
    context?: HttpContext,
  ): Observable<JwtAuthenticationResponse> {
    const resp = this.membersGoogleLoginPost$Response(params, context);
    return resp.pipe(
      map(
        (
          r: StrictHttpResponse<JwtAuthenticationResponse>,
        ): JwtAuthenticationResponse => r.body,
      ),
    );
  }

  /** Path part for operation `membersLastVisitPut()` */
  static readonly MembersLastVisitPutPath = '/members/last-visit';

  /**
   * Put Last Visit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `membersLastVisitPut()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersLastVisitPut$Response(
    params?: MembersLastVisitPut$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<LastVisitResponse>> {
    const obs = membersLastVisitPut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Put Last Visit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `membersLastVisitPut$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersLastVisitPut(
    params?: MembersLastVisitPut$Params,
    context?: HttpContext,
  ): Observable<LastVisitResponse> {
    const resp = this.membersLastVisitPut$Response(params, context);
    return resp.pipe(
      map(
        (r: StrictHttpResponse<LastVisitResponse>): LastVisitResponse => r.body,
      ),
    );
  }

  /** Path part for operation `login()` */
  static readonly LoginPath = '/members/login';

  /**
   * Login.
   *
   * Login with email and password
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `login()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  login$Response(
    params: Login$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<JwtAuthenticationResponse>> {
    const obs = login(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Login.
   *
   * Login with email and password
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `login$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  login(
    params: Login$Params,
    context?: HttpContext,
  ): Observable<JwtAuthenticationResponse> {
    const resp = this.login$Response(params, context);
    return resp.pipe(
      map(
        (
          r: StrictHttpResponse<JwtAuthenticationResponse>,
        ): JwtAuthenticationResponse => r.body,
      ),
    );
  }

  /** Path part for operation `membersMeGet()` */
  static readonly MembersMeGetPath = '/members/me';

  /**
   * Me.
   *
   * Get current user information
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `membersMeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersMeGet$Response(
    params?: MembersMeGet$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<UserResponse>> {
    const obs = membersMeGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Me.
   *
   * Get current user information
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `membersMeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersMeGet(
    params?: MembersMeGet$Params,
    context?: HttpContext,
  ): Observable<UserResponse> {
    const resp = this.membersMeGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserResponse>): UserResponse => r.body),
    );
  }

  /** Path part for operation `membersMeDelete()` */
  static readonly MembersMeDeletePath = '/members/me';

  /**
   * Delete.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `membersMeDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersMeDelete$Response(
    params?: MembersMeDelete$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<void>> {
    const obs = membersMeDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `membersMeDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersMeDelete(
    params?: MembersMeDelete$Params,
    context?: HttpContext,
  ): Observable<void> {
    const resp = this.membersMeDelete$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `membersMeCountryGet()` */
  static readonly MembersMeCountryGetPath = '/members/me-country';

  /**
   * User Country Response.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `membersMeCountryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersMeCountryGet$Response(
    params?: MembersMeCountryGet$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<UserCountryResponse>> {
    const obs = membersMeCountryGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * User Country Response.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `membersMeCountryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersMeCountryGet(
    params?: MembersMeCountryGet$Params,
    context?: HttpContext,
  ): Observable<UserCountryResponse> {
    const resp = this.membersMeCountryGet$Response(params, context);
    return resp.pipe(
      map(
        (r: StrictHttpResponse<UserCountryResponse>): UserCountryResponse =>
          r.body,
      ),
    );
  }

  /** Path part for operation `membersNotifyPurchasePut()` */
  static readonly MembersNotifyPurchasePutPath = '/members/notify-purchase';

  /**
   * Notify External Purchase.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `membersNotifyPurchasePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  membersNotifyPurchasePut$Response(
    params: MembersNotifyPurchasePut$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<void>> {
    const obs = membersNotifyPurchasePut(
      this.http,
      this.rootUrl,
      params,
      context,
    );
    return obs;
  }

  /**
   * Notify External Purchase.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `membersNotifyPurchasePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  membersNotifyPurchasePut(
    params: MembersNotifyPurchasePut$Params,
    context?: HttpContext,
  ): Observable<void> {
    const resp = this.membersNotifyPurchasePut$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `membersRegisterPost()` */
  static readonly MembersRegisterPostPath = '/members/register';

  /**
   * Register.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `membersRegisterPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  membersRegisterPost$Response(
    params: MembersRegisterPost$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<void>> {
    const obs = membersRegisterPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Register.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `membersRegisterPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  membersRegisterPost(
    params: MembersRegisterPost$Params,
    context?: HttpContext,
  ): Observable<void> {
    const resp = this.membersRegisterPost$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `membersRegisterEmailPut()` */
  static readonly MembersRegisterEmailPutPath = '/members/register/email';

  /**
   * Confirm Email.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `membersRegisterEmailPut()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersRegisterEmailPut$Response(
    params: MembersRegisterEmailPut$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<void>> {
    const obs = membersRegisterEmailPut(
      this.http,
      this.rootUrl,
      params,
      context,
    );
    return obs;
  }

  /**
   * Confirm Email.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `membersRegisterEmailPut$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersRegisterEmailPut(
    params: MembersRegisterEmailPut$Params,
    context?: HttpContext,
  ): Observable<void> {
    const resp = this.membersRegisterEmailPut$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `membersResendEmailPost()` */
  static readonly MembersResendEmailPostPath = '/members/resend-email';

  /**
   * Resend Email.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `membersResendEmailPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersResendEmailPost$Response(
    params?: MembersResendEmailPost$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<void>> {
    const obs = membersResendEmailPost(
      this.http,
      this.rootUrl,
      params,
      context,
    );
    return obs;
  }

  /**
   * Resend Email.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `membersResendEmailPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersResendEmailPost(
    params?: MembersResendEmailPost$Params,
    context?: HttpContext,
  ): Observable<void> {
    const resp = this.membersResendEmailPost$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `membersResetPasswordPut()` */
  static readonly MembersResetPasswordPutPath = '/members/reset-password';

  /**
   * Reset Password.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `membersResetPasswordPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  membersResetPasswordPut$Response(
    params: MembersResetPasswordPut$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<void>> {
    const obs = membersResetPasswordPut(
      this.http,
      this.rootUrl,
      params,
      context,
    );
    return obs;
  }

  /**
   * Reset Password.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `membersResetPasswordPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  membersResetPasswordPut(
    params: MembersResetPasswordPut$Params,
    context?: HttpContext,
  ): Observable<void> {
    const resp = this.membersResetPasswordPut$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `membersSalesGet()` */
  static readonly MembersSalesGetPath = '/members/sales';

  /**
   * Get Sales.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `membersSalesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersSalesGet$Response(
    params?: MembersSalesGet$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<SaleResponse>> {
    const obs = membersSalesGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get Sales.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `membersSalesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersSalesGet(
    params?: MembersSalesGet$Params,
    context?: HttpContext,
  ): Observable<SaleResponse> {
    const resp = this.membersSalesGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SaleResponse>): SaleResponse => r.body),
    );
  }

  /** Path part for operation `membersVerifyPost()` */
  static readonly MembersVerifyPostPath = '/members/verify';

  /**
   * Very Account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `membersVerifyPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersVerifyPost$Response(
    params?: MembersVerifyPost$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<void>> {
    const obs = membersVerifyPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Very Account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `membersVerifyPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  membersVerifyPost(
    params?: MembersVerifyPost$Params,
    context?: HttpContext,
  ): Observable<void> {
    const resp = this.membersVerifyPost$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }
}
